import GestionVentasModulo from "./GestionVentasModulo";

export default GestionVentasModulo;
